/* Constantes sem dependências: o app importa daqui para não levar o Zod para o navegador. */

export const APP_VERSION = '0.8.1';
export const APP_STAGE = '4';

export const DEFAULT_TIMEZONE = 'America/Sao_Paulo';

export function isValidTimeZone(tz: string): boolean {
  try { new Intl.DateTimeFormat('en-US', { timeZone: tz }); return true; } catch { return false; }
}

export const PROJECT_STATUSES = ['planning', 'active', 'paused', 'done'] as const;
export type ProjectStatus = (typeof PROJECT_STATUSES)[number];
export const PROJECT_STATUS_LABEL: Record<ProjectStatus, string> = {
  planning: 'Planejamento', active: 'Em andamento', paused: 'Pausado', done: 'Concluído'
};

export const DELETE_ALL_PHRASE = 'APAGAR TUDO';
export const DELETE_ACCOUNT_PHRASE = 'EXCLUIR CONTA';

/* Cabeçalho exigido em toda requisição que altera dados: força preflight de CORS em
   chamadas de outras origens, bloqueando formulários forjados (CSRF). */
export const CLIENT_HEADER = 'X-Jarvis-Client';
